import { Form, Formik } from "formik";
import { object, string } from "yup";
import PasswordInput from "../UI/PasswordInput";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Button from "../UI/Button";
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";
import useAccount from "../../hooks/use-account";
import { handleAPIError } from "../../utils/index.jsx";
import { useState } from "react";
import Callout from "../UI/Callout.tsx";
import styles from "./TwoFactorAuthDisableForm.module.css";

export default function TwoFactorAuthDisableForm({ onClose }) {
  const axios = useAuthenticatedAxios();
  const { refresh: refreshAccount } = useAccount();
  const [error, setError] = useState("");

  async function disableHandler(values) {
    try {
      setError("");
      await axios.post("/account/totp/disable", { password: values.password });
      await refreshAccount();
      onClose();
    } catch (error) {
      setError(handleAPIError(error));
    }
  }

  return (
    <div>
      <p className={"cardTitle"}>
        Désactiver l'authentification à deux facteurs
      </p>
      <p className={"marginT10 marginB10"}>
        Pour confirmer la désactivation, veuillez entrer votre mot de passe.
      </p>
      <Formik
        initialValues={{ password: "" }}
        validationSchema={object({
          password: string().required("Mot de passe requis"),
        })}
        onSubmit={disableHandler}
      >
        <Form className={styles.form}>
          <PasswordInput name="password" label="Mot de passe" marginForm="" />
          <div className={styles.actions}>
            <Button variant="secondary" onClick={onClose}>
              Annuler
            </Button>
            <FormikSubmitButton>Désactiver</FormikSubmitButton>
          </div>
          <Callout variant="danger">{error}</Callout>
        </Form>
      </Formik>
    </div>
  );
}
